function PdfIcon({ size }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 30 30'
    >
      <path
        fill='#E5252A'
        fillRule='evenodd'
        d='M7.687 0h10.03l8.501 8.86v17.234A3.901 3.901 0 0122.32 30H7.687a3.903 3.903 0 01-3.905-3.905V3.904A3.903 3.903 0 017.687 0z'
        clipRule='evenodd'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M17.71 0v8.793h8.508L17.71 0z'
        clipRule='evenodd'
        opacity='0.302'
      />
      <path
        fill='#fff'
        d='M8.122 22.384v-5.48h2.331c.578 0 1.035.157 1.38.48.345.315.517.742.517 1.274s-.172.96-.517 1.274c-.345.323-.802.48-1.38.48h-.93v1.972h-1.4zm1.402-3.164h.772c.21 0 .375-.045.487-.15a.515.515 0 00.173-.412c0-.18-.06-.315-.173-.412-.112-.105-.277-.15-.487-.15h-.772v1.124zm3.403 3.164v-5.48h1.942c.382 0 .742.052 1.08.165.336.112.644.27.914.487.27.21.487.495.644.855.15.36.233.772.233 1.237 0 .457-.083.87-.233 1.23-.157.359-.374.644-.644.854-.27.217-.578.374-.915.487a3.392 3.392 0 01-1.08.165h-1.94zm1.372-1.192h.405c.217 0 .42-.023.607-.075.18-.053.352-.135.517-.247a1.11 1.11 0 00.375-.48c.09-.21.135-.457.135-.742 0-.293-.045-.54-.135-.75a1.111 1.111 0 00-.375-.48 1.822 1.822 0 00-.517-.247 2.25 2.25 0 00-.607-.075h-.405v3.096zm4.145 1.192v-5.48h3.899v1.192h-2.497v.877h1.994v1.184h-1.994v2.227h-1.402z'
      />
    </svg>
  );
}

export default PdfIcon;
